export function getApiBaseUrl() {
  // @ts-ignore
  const apiBase = import.meta.env.VITE_API_BASE_URL;
  return apiBase ?? '';
}
